import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BulkDomainNonPaymentBlockingMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  value: Types.NonPaymentBlockingType;
}>;


export type BulkDomainNonPaymentBlockingMutation = { __typename?: 'Mutation', bulkDomainNonPaymentBlocking?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };


export const BulkDomainNonPaymentBlockingDocument = gql`
    mutation BulkDomainNonPaymentBlocking($id: Int!, $value: NonPaymentBlockingType!) {
  bulkDomainNonPaymentBlocking(id: $id, value: $value) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type BulkDomainNonPaymentBlockingMutationFn = Apollo.MutationFunction<BulkDomainNonPaymentBlockingMutation, BulkDomainNonPaymentBlockingMutationVariables>;

/**
 * __useBulkDomainNonPaymentBlockingMutation__
 *
 * To run a mutation, you first call `useBulkDomainNonPaymentBlockingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDomainNonPaymentBlockingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDomainNonPaymentBlockingMutation, { data, loading, error }] = useBulkDomainNonPaymentBlockingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useBulkDomainNonPaymentBlockingMutation(baseOptions?: Apollo.MutationHookOptions<BulkDomainNonPaymentBlockingMutation, BulkDomainNonPaymentBlockingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDomainNonPaymentBlockingMutation, BulkDomainNonPaymentBlockingMutationVariables>(BulkDomainNonPaymentBlockingDocument, options);
      }
export type BulkDomainNonPaymentBlockingMutationHookResult = ReturnType<typeof useBulkDomainNonPaymentBlockingMutation>;
export type BulkDomainNonPaymentBlockingMutationResult = Apollo.MutationResult<BulkDomainNonPaymentBlockingMutation>;
export type BulkDomainNonPaymentBlockingMutationOptions = Apollo.BaseMutationOptions<BulkDomainNonPaymentBlockingMutation, BulkDomainNonPaymentBlockingMutationVariables>;